module.exports = __webpack_public_path__ + "img/cj_1.ecf77a9c.png";